import { setLocalStorage } from '../../../utils/localstorage';
import { useState, useEffect } from 'react';
import { GLOBAL_NAVIGATION_SIDEBAR_DEFAULT_EXPANDED_WIDTH, GLOBAL_NAVIGATION_SIDEBAR_DEFAULT_COLLAPSED_WIDTH } from 'nav-meta/constants';
import { updateRootnavComponentDimension } from '../../../NavLayoutDimensions/utils/updateRootnavComponentDimension';
import { getIsVerticalNavInitiallyCollapsed } from '../../../NavLayoutDimensions/utils/getInitialNavWidth';
import { useAppDispatch } from '../../../hooks';
export const usePin = ({
  isVerticalNavEnabled
}) => {
  const [isPinned, setIsPinned] = useState(!getIsVerticalNavInitiallyCollapsed());
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!isVerticalNavEnabled) {
      updateRootnavComponentDimension('VerticalNav', {
        width: 0
      }, dispatch);
      return;
    }
    if (isPinned) {
      setLocalStorage('VERTICAL_NAV_COLLAPSED', false);
      updateRootnavComponentDimension('VerticalNav', {
        width: parseInt(GLOBAL_NAVIGATION_SIDEBAR_DEFAULT_EXPANDED_WIDTH, 10)
      }, dispatch);
    } else {
      setLocalStorage('VERTICAL_NAV_COLLAPSED', true);
      updateRootnavComponentDimension('VerticalNav', {
        width: parseInt(GLOBAL_NAVIGATION_SIDEBAR_DEFAULT_COLLAPSED_WIDTH, 10)
      }, dispatch);
    }
  }, [isPinned, dispatch, isVerticalNavEnabled]);
  return {
    isPinned,
    setIsPinned
  };
};